<div class="professional-container">
  <form class="form">
    <div class="professional">
      <ul class="professional-body">
        <h3 class="professional-title">Profissionais</h3>
        <li class="professional-items" [class.pfn-items__border]="last" *ngFor="let item of items; let i = index; let last = last">
          <div class="professional-item-container">
            <p *ngIf="item.type"><span>Tipo de profissional: </span>{{ item.type }}</p>
            <p *ngIf="item.name"><span>Profissional: </span>{{ item.name }}</p>
            <p *ngIf="item.enterprise"><span>Empresa: </span>{{ item.enterprise }}</p>
          </div>
          <button class="remove-item" id="btn-remove" (click)="removeItem(i)">
            <img src="../../../../assets/svgs/i_dot_options.svg" alt="Opções">
          </button>
        </li>
        <button id="btn-add" class="btn-add" (click)="openModal()">
          <span>Adicionar proprietário</span>
        </button>
      </ul>
    </div>
    <div class="btn-actions">
      <lib-button-tertiary>Cancelar</lib-button-tertiary>
      <lib-button-primary>Salvar</lib-button-primary>
    </div>
  </form>
</div>
<app-professional-modal *ngIf="showModal" titleModal="Adicionar profissional" (closeModal)="showModal = $event" (sendItems)="getRequest($event)"></app-professional-modal>